import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

import { Grid, Box } from '@chatterbug/aaron'
import { PAGE_HORIZONTAL_PADDING } from 'src/ui/PageLayout/PageLayout'

const MAX_CARDS_TO_SHOW = 3
const CARD_WIDTH = 235
const CARDS_GAP = 24
const MIN_WIDTH =
  CARD_WIDTH * MAX_CARDS_TO_SHOW + CARDS_GAP * (MAX_CARDS_TO_SHOW - 1)

const DEFAULT_PAGE_SIDE_GAP = {
  _: PAGE_HORIZONTAL_PADDING._,
  mobile: PAGE_HORIZONTAL_PADDING.mobile,
}

const getNegativeSideGap = (theme, parentSideGap) => {
  return Object.keys(parentSideGap).reduce((result, breakpoint) => {
    const gap = parentSideGap[breakpoint]
    result[breakpoint] = gap === 0 ? 0 : `-${theme.space[gap]}`
    return result
  }, {})
}

const UnitExercisesPreviewSkeleton = ({
  titleSection,
  moreSection,
  items,
  ItemComponent,
  parentSideGap = DEFAULT_PAGE_SIDE_GAP,
  theme,
}) => {
  const extraItem =
    items.length > MAX_CARDS_TO_SHOW ? items[MAX_CARDS_TO_SHOW] : null

  return (
    <Box as="section">
      <Grid gap="3x" columns={2} alignItems="center">
        <Box as="h3" variant="text.h5">
          {titleSection}
        </Box>
        <Box sx={{ textAlign: 'right' }}>{moreSection}</Box>
      </Grid>
      <Box
        mt="2x"
        mx={getNegativeSideGap(theme, parentSideGap)}
        pb="2x" // for drop shadows. otherwise they will be cut by overflowX
        sx={{
          overflowX: 'auto',
        }}
      >
        <Grid
          gap="3x"
          gridTemplateColumns={{
            _: `repeat(3, ${CARD_WIDTH}px)`,
            mobile: `repeat(${MAX_CARDS_TO_SHOW}, 1fr)`,
            desktop: `repeat(${MAX_CARDS_TO_SHOW + 1}, 1fr)`,
          }}
          minWidth={{ _: MIN_WIDTH, tablet: 0 }}
          sx={{
            boxSizing: 'content-box',
          }}
          px={parentSideGap}
        >
          {items.slice(0, MAX_CARDS_TO_SHOW).map((item) => (
            <ItemComponent key={item.id} {...item} />
          ))}
          {extraItem && ( // extra card for large screens
            <Box display={{ _: 'none', desktop: 'flex' }}>
              <ItemComponent {...extraItem} />
            </Box>
          )}
        </Grid>
      </Box>
    </Box>
  )
}

UnitExercisesPreviewSkeleton.propTypes = {
  titleSection: PropTypes.any,
  moreSection: PropTypes.any,
  parentSideGap: PropTypes.object,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
  ItemComponent: PropTypes.func.isRequired,
  theme: PropTypes.object,
}

export default withTheme(UnitExercisesPreviewSkeleton)
